export const DataAnalyticsBannerContentArabic = {
    mainHeading: "خدمات",
    greenHeading: "تحليلات البيانات",
    subHeadingGreen: "موثوق بها من قبل الشركات الناشئة، والشركات الصغيرة والمتوسطة، والمؤسسات على حد سواء",
    sectionDescription: "حوّل بياناتك الخام إلى رؤى قابلة للتنفيذ، واتخذ قرارات مستنيرة، وابقَ متقدمًا باستخدام خدمات تحليلات البيانات لدينا.",
    bannerButtonText: "هيا بنا نبدأ"
};

export const DataAndAnalyticsServicesDataArabic = {
    DataAndAnalyticsServicesDataContent: {
        mainHeading: "خدمات البيانات والتحليلات الشاملة لعملك",
        sectionDescription: "بصفتنا إحدى أفضل شركات تحليلات البيانات، فإننا نجمع بين التحليلات المتقدمة والرؤى المدفوعة بالذكاء الاصطناعي وذكاء الأعمال لمساعدتك في اتخاذ قرارات مستنيرة وتحسين العمليات ودفع النمو. سواء كنت بحاجة إلى تحليلات تنبؤية أو تصور البيانات أو استشارات تحليلات البيانات، فإن فريق الخبراء لدينا هنا لتقديم حلول مخصصة تحول بياناتك الخام إلى رؤى قابلة للتنفيذ."
    },

    DataAndAnalyticsServicesDataTabs: [
        {
            id: "Tab1",
            label: "تحليلات البيانات وتصورها",
            content:
                "اطلق العنان لقوة بياناتك من خلال خدماتنا المتقدمة في التحليلات وتصور البيانات. نحن نحول البيانات الخام إلى رؤى قابلة للتنفيذ باستخدام أحدث الأدوات والتقنيات. تساعدك حلولنا على اتخاذ قرارات مدفوعة بالبيانات وتقديم معلومات معقدة بتنسيق مرئي سهل الفهم.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/data-analytics/sql.png",
                },
                {
                    img: "/images/services-icons/data-analytics/AirflowLogo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Apache_Spark_logo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Superset.png",
                },
            ],
        },
        {
            id: "Tab2",
            label: "حلول البيانات الضخمة",
            content:
                "استغل إمكانات البيانات الضخمة من خلال حلولنا القابلة للتطوير والفعالة. نقوم بتصميم وتنفيذ معماريات البيانات الضخمة التي تعالج وتخزن وتحلل مجموعات البيانات الضخمة. تتيح لك خدماتنا استخراج رؤى قيمة والبقاء في المقدمة في عالم يعتمد على البيانات.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/data-analytics/sql.png",
                },
                {
                    img: "/images/services-icons/data-analytics/AirflowLogo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Apache_Spark_logo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Superset.png",
                },
            ],
        },
        {
            id: "Tab3",
            label: "خدمات ذكاء الأعمال (BI)",
            content:
                "مكّن عملك من خلال خدمات ذكاء الأعمال الشاملة لدينا. نحن ننشئ حلول ذكاء الأعمال المخصصة التي تدمج البيانات من مصادر متعددة، وتوفر رؤى في الوقت الفعلي ولوحات معلومات تفاعلية. تساعدك أدوات ذكاء الأعمال لدينا على مراقبة الأداء وتحديد الاتجاهات ودفع النمو.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/data-analytics/sql.png",
                },
                {
                    img: "/images/services-icons/data-analytics/AirflowLogo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Apache_Spark_logo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Superset.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "التحليلات التنبؤية",
            content:
                "ابقَ في صدارة المنافسة من خلال خدمات التحليلات التنبؤية لدينا. باستخدام التعلم الآلي المتقدم والنماذج الإحصائية، نقوم بتحليل البيانات التاريخية للتنبؤ بالاتجاهات والسلوكيات المستقبلية. تساعدك حلول التحليلات التنبؤية لدينا على اتخاذ قرارات استباقية وتخفيف المخاطر.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/data-analytics/sql.png",
                },
                {
                    img: "/images/services-icons/data-analytics/AirflowLogo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Apache_Spark_logo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Superset.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "تخزين البيانات",
            content:
                "قم ببناء أساس قوي لبياناتك من خلال خدمات تخزين البيانات لدينا. نقوم بتصميم وتنفيذ مستودعات بيانات مركزية تخزن وتنظم بياناتك لسهولة الوصول والتحليل. تضمن حلول تخزين البيانات لدينا سلامة البيانات وقابلية التوسع والأداء.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/data-analytics/sql.png",
                },
                {
                    img: "/images/services-icons/data-analytics/AirflowLogo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Apache_Spark_logo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Superset.png",
                },
            ],
        },
        {
            id: "Tab6",
            label: "تكامل البيانات و ETL",
            content:
                "قم بتبسيط تدفقات عمل بياناتك من خلال خدمات تكامل البيانات و ETL (الاستخراج، التحويل، التحميل) لدينا. نقوم بربط مصادر البيانات المتباينة، وتحويل البيانات الخام إلى تنسيقات ذات مغزى، وتحميلها في أنظمتك. تضمن حلولنا تدفقًا سلسًا للبيانات واتساقها عبر مؤسستك.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/data-analytics/sql.png",
                },
                {
                    img: "/images/services-icons/data-analytics/AirflowLogo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Apache_Spark_logo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Superset.png",
                },
            ],
        },
        {
            id: "Tab7",
            label: "حوكمة البيانات والامتثال",
            content:
                "تأكد من أن بياناتك آمنة ودقيقة ومتوافقة مع خدمات حوكمة البيانات لدينا. نساعدك على وضع السياسات والإجراءات والأطر لإدارة البيانات بفعالية. تضمن حلولنا الامتثال للوائح الصناعية وتبني الثقة في أصول بياناتك.",
            btnText: "دعنا نناقش",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/data-analytics/sql.png",
                },
                {
                    img: "/images/services-icons/data-analytics/AirflowLogo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Apache_Spark_logo.png",
                },
                {
                    img: "/images/services-icons/data-analytics/Superset.png",
                },
            ],
        },
    ]
}

export const DataAnalyticsTypesOfBuildSectionArabic = {
    heading: "حل تحديات بياناتك من خلال تحليلات الخبراء",
    typeOfApps: [
        {
            id: "collapseOne",
            question: "فهم البيانات المعقدة وتبسيطها",
            answer: {
                discription:
                    "يمكن أن يكون فهم البيانات المعقدة تحديًا، لكننا نحول مجموعات البيانات الهائلة إلى رؤى واضحة وقابلة للتنفيذ. تعمل خدمات التحليلات لدينا على تقسيم المعلومات المعقدة إلى مرئيات وتقارير سهلة الفهم، مما يضمن أن بياناتك تسرد قصة متماسكة تدعم قرارات العمل الذكية.",
                listContent: [
                    {
                        line: "تحويل البيانات المعقدة إلى رؤى واضحة وقابلة للتنفيذ",
                    },
                    {
                        line: "تبسيط مجموعات البيانات بتقارير ومرئيات سهلة الاستخدام",
                    },
                    {
                        line: "مساعدة الفرق على فهم ذكاء الأعمال والاستفادة منه",
                    },
                    {
                        line: "توفير تفسير منظم للبيانات لاتخاذ قرارات أفضل",
                    },
                    {
                        line: "ضمان توافق الرؤى مع أهداف واستراتيجيات العمل",
                    },
                ],
            },
        },
        {
            id: "collapseTwo",
            question: "إدارة حمولة البيانات الزائدة",
            answer: {
                discription:
                    "يمكن أن تكون البيانات الكثيرة جدًا مرهقة، مما يجعل من الصعب التركيز على ما يهم. نساعدك على تصفية البيانات وتحديد أولوياتها وتنظيمها، مما يضمن أنك تعمل فقط بمعلومات ذات صلة وعالية التأثير. تحول حلولنا البيانات الزائدة إلى رؤى منظمة تحسن الكفاءة واتخاذ القرارات.",
                listContent: [
                    {
                        line: "تصفية البيانات وتحديد أولوياتها للتركيز على ما يهم أكثر",
                    },
                    {
                        line: "تنظيم المعلومات غير المهيكلة في رؤى ذات مغزى",
                    },
                    {
                        line: "تبسيط تحليل البيانات لتحسين الإنتاجية",
                    },
                    {
                        line: "إزالة الضوضاء والبيانات غير ذات الصلة لتحقيق وضوح أفضل",
                    },
                    {
                        line: "تعزيز الكفاءة عن طريق هيكلة البيانات وتقسيمها",
                    },
                ],
            },
        },
        {
            id: "collapseThree",
            question: "معالجة مخاوف أمان البيانات",
            answer: {
                discription:
                    "أمان البيانات أكثر أهمية من أي وقت مضى، ونحن نتأكد من أن معلوماتك تظل محمية. من التشفير إلى التخزين الآمن، تعطي حلول التحليلات لدينا الأولوية لسلامة البيانات مع ضمان الامتثال للوائح الصناعية. نحن نحمي رؤىك حتى تتمكن من التركيز على النمو.",
                listContent: [
                    {
                        line: "تنفيذ أفضل الممارسات لتشفير البيانات وأمانها",
                    },
                    {
                        line: "حماية بيانات الأعمال والعملاء الحساسة من الاختراقات",
                    },
                    {
                        line: "ضمان الامتثال لخصوصية البيانات والمعايير التنظيمية",
                    },
                    {
                        line: "منع الوصول غير المصرح به من خلال بروتوكولات أمنية صارمة",
                    },
                    {
                        line: "مراقبة وإدارة المخاطر من خلال تدابير أمنية استباقية",
                    },
                ],
            },
        },
        {
            id: "fourth",
            question: "دمج مصادر البيانات غير المتصلة",
            answer: {
                discription:
                    "غالبًا ما تخلق البيانات من مصادر متعددة صوامع تعطل عملية اتخاذ القرار. نحن نجمع كل بياناتك المتناثرة معًا، وندمج المنصات وقواعد البيانات المختلفة في نظام واحد سلس. وهذا يضمن الاتساق والدقة ورؤية موحدة لعمليات عملك.",
                listContent: [
                    {
                        line: "توحيد مصادر البيانات غير المتصلة في نظام واحد متكامل",
                    },
                    {
                        line: "تحسين الدقة عن طريق إزالة البيانات الزائدة والمتضاربة",
                    },
                    {
                        line: "تعزيز التعاون من خلال اتصال البيانات السلس",
                    },
                    {
                        line: "ضمان سهولة الوصول إلى الرؤى الموحدة في الوقت الفعلي",
                    },
                    {
                        line: "تبسيط تدفقات عمل البيانات لتحسين الكفاءة التشغيلية",
                    },
                ],
            },
        },
        {
            id: "fifth",
            question: "تحسين عملية اتخاذ القرار باستخدام رؤى البيانات",
            answer: {
                discription:
                    "القرارات العظيمة تتطلب بيانات قوية. لا تقدم خدمات التحليلات لدينا مجرد تقارير، بل تقدم استراتيجيات تعتمد على البيانات تتنبأ بالاتجاهات، وتحسن العمليات، وتدفع نجاح الأعمال. نحن نزودك بالرؤى اللازمة لاتخاذ خيارات واثقة ومستنيرة.",
                listContent: [
                    {
                        line: "تقديم رؤى في الوقت الفعلي لاتخاذ قرارات أكثر ذكاءً",
                    },
                    {
                        line: "تحديد الأنماط والاتجاهات باستخدام تحليلات البيانات المتقدمة",
                    },
                    {
                        line: "دعم التخطيط المستقبلي بنماذج التحليلات التنبؤية",
                    },
                    {
                        line: "تحسين استراتيجيات العمل من خلال إرشادات دقيقة ومدعومة بالبيانات",
                    },
                    {
                        line: "ضمان نتائج أفضل بقرارات مستنيرة ومدفوعة بالبيانات",
                    },
                ],
            },
        },
    ],
};

export const AnalyticsWhoWeServeDataArabic = {
    sectionContent: {
        heading: "من نخدم",
        description: "البيانات هي العمود الفقري للأعمال الحديثة، وتساعد خدمات تحليل البيانات لدينا الشركات على تحويل المعلومات الخام إلى رؤى قابلة للتنفيذ. من الشركات الناشئة التي تبحث عن استراتيجيات تعتمد على البيانات إلى الشركات التي تحتاج إلى حلول ذكاء الأعمال، نقدم حلولًا قابلة للتطوير ومصممة خصيصًا للجميع."
    },
    cardsContent: [
        {
            icon: "/images/servie-icon/startups.svg",
            title: "الشركات الناشئة",
            description:
                "استفد من قوة خدمات تحليل البيانات لاتخاذ قرارات مستنيرة، وتحسين العمليات، وفهم سلوك العملاء لدفع النمو.",
            serveList: [
                "تحديد اتجاهات السوق من خلال التحليلات التنبؤية.",
                "استخدام رؤى في الوقت الفعلي لتحسين المنتجات والخدمات.",
                "اتخاذ قرارات مدعومة بالبيانات للتوسع بكفاءة.",
            ],
            link: "#",
            borderClass: "border-1",
        },
        {
            icon: "/images/servie-icon/company.png",
            title: "شركات التكنولوجيا وشركات SaaS",
            description:
                "حوّل تحليلات البيانات الضخمة لديك إلى ميزة تنافسية باستخدام أدوات متطورة تعزز الأتمتة وإعداد التقارير والرؤى المدفوعة بالذكاء الاصطناعي.",
            serveList: [
                "تعزيز ذكاء المنصة بنماذج التعلم الآلي.",
                "تحسين التحليلات السحابية للأداء والكفاءة.",
                "دمج التحليلات في الوقت الفعلي في تطبيقات SaaS.",
            ],
            link: "#",
            borderClass: "border-2",
        },
        {
            icon: "/images/servie-icon/industries.svg",
            title: "الشركات والمؤسسات الكبيرة",
            description:
                "استفد من حلول ذكاء الأعمال لتبسيط العمليات، وتحسين التنبؤ، وتعزيز الكفاءة العامة باستخدام استراتيجيات بيانات مخصصة.",
            serveList: [
                "تحسين التنبؤ المالي والتخطيط التشغيلي.",
                "أتمتة إعداد التقارير برؤى الأعمال المدفوعة بالذكاء الاصطناعي.",
                "استخدام نماذج بيانات قابلة للتطوير للتحليل على مستوى المؤسسة.",
            ],
            link: "#",
            borderClass: "border-3",
        },
    ]
}

export const AnalyticsWhyChooseBitsclanDataArabic = {
    sectionContent: {
        mainHeading: "لماذا تختار بيتسكلان كشريكك في تحليلات البيانات؟",
        sectionDescription: "يعد اختيار المزود المناسب لخدمات تحليلات البيانات أمرًا أساسيًا لفتح الباب أمام النمو القائم على البيانات. نحن نبسّط تحليلات البيانات الضخمة، ونبسط حلول ذكاء الأعمال، ونقدم استشارات بيانات مخصصة لاحتياجاتك. يضمن نهجنا القائم على الخبراء استراتيجيات تعتمد على البيانات تزيد الكفاءة، وتكشف عن رؤى خفية، وتدفع اتخاذ القرارات المستنيرة."
    },
    tabsData: [
        {
            id: "Tab1",
            label: "الجودة لأنها تهم",
            content:
                "نقدم خدمات تحليلات البيانات بدقة، مما يضمن رؤى عالية الجودة من خلال معالجة البيانات الآلية والتحقق والتحسين.",
            btnText: "تواصل مع العشيرة",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "أفضل المواهب من الطراز الأول",
            content:
                "يتكون فريقنا من علماء بيانات، ومحللين، ومخططين استراتيجيين يحولون البيانات الخام إلى حلول ذكاء أعمال قابلة للتنفيذ.",
            btnText: "تواصل مع العشيرة",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "محاذاة المنطقة الزمنية",
            content:
                "نحن نضمن التعاون السلس من خلال التوافق مع منطقتك الزمنية، مما يتيح إعداد التقارير في الوقت الفعلي، وعمليات سلسة، واتخاذ قرارات أسرع.",
            btnText: "تواصل مع العشيرة",
            btnLink: "#",
        },
        {
            id: "Tab4",
            label: "حلول قابلة للتطوير وجاهزة للمستقبل",
            content:
                "تتوسع حلول تحليلات البيانات الضخمة لدينا مع عملك، وتدمج الأتمتة المدفوعة بالذكاء الاصطناعي للحصول على رؤى تنبؤية ونمو طويل الأجل.",
            btnText: "تواصل مع العشيرة",
            btnLink: "#",
        },
        {
            id: "Tab5",
            label: "الأمان والامتثال أولاً",
            content:
                "نحن نعطي الأولوية لأمان البيانات، مما يضمن الامتثال لمعايير الصناعة بحيث تظل بياناتك الحساسة محمية وجاهزة للتنظيم.",
            btnText: "تواصل مع العشيرة",
            btnLink: "#",
        },
    ]
}

export const AnalyticsHighvaluesDataArabic = {
    mainHeading: "ميزات عالية القيمة لحلول تحليلات البيانات",
    sectionDescription: "توفر خدمات تحليلات البيانات لدينا ميزات من الدرجة الأولى تحول البيانات المعقدة إلى رؤى ذات مغزى. من التحليلات المتقدمة وتكامل البيانات إلى الحلول القابلة للتطوير وإعداد التقارير في الوقت الفعلي، تم تصميم ميزاتنا لضمان دقة البيانات وأمانها ورؤى قابلة للتنفيذ لتحسين عملية اتخاذ القرار ونمو الأعمال.",
    buttonText: "استشر نطاق المشروع",
    highValueCardData: [
        {
            image: "data-anylytics-icon1.svg",
            text: "حلول تحليلات البيانات المخصصة",
        },
        {
            image: "data-anylytics-icon2.svg",
            text: "رؤى البيانات في الوقت الفعلي",
        },
        {
            image: "data-anylytics-icon3.svg",
            text: "تكامل التحليلات المتقدمة",
        },
        {
            image: "data-anylytics-icon4.svg",
            text: "حلول بيانات قابلة للتطوير",
        },
        {
            image: "data-anylytics-icon5.svg",
            text: "لوحات معلومات موجهة للمستخدم",
        },
        {
            image: "data-anylytics-icon6.svg",
            text: "معالجة بيانات آمنة",
        },
        {
            image: "data-anylytics-icon7.svg",
            text: "تحليلات البيانات الضخمة",
        },
        {
            image: "data-anylytics-icon8.svg",
            text: "اتخاذ القرارات القائمة على البيانات",
        },
        {
            image: "data-anylytics-icon9.svg",
            text: "تحليلات البيانات الآلية",
        },
        {
            image: "data-anylytics-icon10.svg",
            text: "صيانة البيانات المستمرة",
        },
    ]
}

export const dataAnalyticsCoverTheStackDataArabic = {
    sectionContent: {
        mainHeading: "حزمة تقنياتنا المتقدمة لتحليلات البيانات",
        sectionDescription: "تستخدم خدمات تحليلات البيانات لدينا حزمة تقنية قوية لمواجهة تحديات البيانات المعقدة، مما يضمن معالجة دقيقة، وتحليلات ثاقبة، وإدارة آمنة.",
        defaultTabOpen: "نماذج الذكاء الاصطناعي التوليدي" // Translated defaultTabOpen too
    },

    tabs: [
        "نماذج الذكاء الاصطناعي التوليدي",
        "الوحدات/مجموعات الأدوات",
        "أطر التعلم العميق (DL)",
        "الشبكات العصبية",
        "المكتبات",
        "نماذج تصنيف الصور",
    ],

    tabItems: [
        {
            tab: "نماذج الذكاء الاصطناعي التوليدي",
            icon: "/images/genai1.svg",
            name: "CycleGAN",
        },
        {
            tab: "نماذج الذكاء الاصطناعي التوليدي",
            icon: "/images/genai2.svg",
            name: "DeepArt",
        },
        {
            tab: "نماذج الذكاء الاصطناعي التوليدي",
            icon: "/images/genai3.svg",
            name: "DeepDream",
        },
        { tab: "نماذج الذكاء الاصطناعي التوليدي", icon: "/images/genai4.svg", name: "VQ-VAE" },
        { tab: "نماذج الذكاء الاصطناعي التوليدي", icon: "/images/genai5.svg", name: "GPT-4" },
        { tab: "نماذج الذكاء الاصطناعي التوليدي", icon: "/images/genai6.svg", name: "GPT-3" },
        { tab: "نماذج الذكاء الاصطناعي التوليدي", icon: "/images/genai6.svg", name: "DALL-E" },
        { tab: "الوحدات/مجموعات الأدوات", icon: "/images/genai6.svg", name: "OpenAI GPT" },
        {
            tab: "الوحدات/مجموعات الأدوات",
            icon: "/images/genai6.svg",
            name: "OpenAI DALL-E",
        },
        {
            tab: "الوحدات/مجموعات الأدوات",
            icon: "/images/module1.svg",
            name: "DeepMind Sonnet",
        },
        {
            tab: "الوحدات/مجموعات الأدوات",
            icon: "/images/module2.svg",
            name: "Facebook AI Research ",
        },
        {
            tab: "الوحدات/مجموعات الأدوات",
            icon: "/images/module3.svg",
            name: "Hugging Face",
        },
        {
            tab: "الوحدات/مجموعات الأدوات",
            icon: "/images/module4.svg",
            name: "NVIDIA StyleGAN",
        },
        {
            tab: "أطر التعلم العميق (DL)",
            icon: "/images/tech-icon.svg",
            name: "PyTorch",
        },
        {
            tab: "أطر التعلم العميق (DL)",
            icon: "/images/tech-icon2.svg",
            name: "Keras",
        },
        {
            tab: "أطر التعلم العميق (DL)",
            icon: "/images/tech-icon3.svg",
            name: "MXNet",
        },
        {
            tab: "أطر التعلم العميق (DL)",
            icon: "/images/tech-icon4.svg",
            name: "TensorFlow",
        },
        {
            tab: "أطر التعلم العميق (DL)",
            icon: "/images/tech-icon5.svg",
            name: "Caffe",
        },
        { tab: "الشبكات العصبية", icon: "/images/natural1.svg", name: "RBM" },
        { tab: "الشبكات العصبية", icon: "/images/natural2.svg", name: "DBN" },
        {
            tab: "الشبكات العصبية",
            icon: "/images/natural7.svg",
            name: "Transformers",
        },
        {
            tab: "الشبكات العصبية",
            icon: "/images/natural4.svg",
            name: "Autoencoders",
        },
        { tab: "الشبكات العصبية", icon: "/images/natural5.svg", name: "DRLN" },
        { tab: "الشبكات العصبية", icon: "/images/natural6.svg", name: "GAN" },
        { tab: "المكتبات", icon: "/images/tech-icon.svg", name: "PyTorch" },
        { tab: "المكتبات", icon: "/images/tech-icon2.svg", name: "Keras" },
        { tab: "المكتبات", icon: "/images/tech-icon3.svg", name: "MXNet" },
        { tab: "المكتبات", icon: "/images/libraries1.svg", name: "FastAI" },
        { tab: "المكتبات", icon: "/images/libraries2.svg", name: "TensorFlow" },
        { tab: "المكتبات", icon: "/images/libraries3.svg", name: "Theano" },
        { tab: "المكتبات", icon: "/images/libraries4.svg", name: "Scikit-learn" },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification.svg",
            name: "AlexNet",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification2.svg",
            name: "EfficientNet",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification3.svg",
            name: "Xception",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification4.svg",
            name: "DenseNet",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification5.svg",
            name: "Inception",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification6.svg",
            name: "ResNet",
        },
        {
            tab: "نماذج تصنيف الصور",
            icon: "/images/calsification7.svg",
            name: "VGGNet",
        },
    ]
}

export const industriesHeadingArabic = {
    mainHeading: "الصناعات التي نخدمها تحليلات البيانات"
}

export const faqDataArabic = {
    sectionContent: {
        mainHeading: "الأسئلة الشائعة",
        sectionDescription: "استكشف الأسئلة الرئيسية حول خدمات تحليلات البيانات لدينا، من التكاليف إلى البدء وتعظيم قيمة الأعمال."
    },

    questionAndAnswer: [
        {
            id: "collapseOne",
            question:
                "ما هي تحليلات البيانات، ولماذا هي مهمة؟",
            answer:
                "تتضمن تحليلات البيانات فحص البيانات وتنظيفها ونمذجتها لاكتشاف معلومات مفيدة، ودعم اتخاذ القرارات، وتحسين العمليات التجارية. إنها تساعد الشركات على تحسين الأداء، والتنبؤ بالاتجاهات، واتخاذ قرارات تعتمد على البيانات.",
        },
        {
            id: "collapseTwo",
            question:
                "كيف يمكن لتحليلات البيانات تحسين عملي؟",
            answer:
                "باستخدام تحليلات البيانات، يمكنك فتح رؤى قيمة من بياناتك لفهم عملائك، وتبسيط العمليات، وتحديد فرص النمو. وهذا يؤدي إلى اتخاذ قرارات أفضل وتحسين الأداء.",
        },
        {
            id: "collapseThree",
            question:
                "ما الفرق بين تحليلات البيانات الضخمة والتحليلات العادية؟",
            answer:
                "تتعامل تحليلات البيانات الضخمة مع كميات كبيرة من البيانات المهيكلة وغير المهيكلة، غالبًا في الوقت الفعلي. تركز التحليلات العادية عادةً على مجموعات بيانات أصغر، وتقدم رؤى من الاتجاهات الماضية بدلاً من التنبؤات المستقبلية.",
        },
        {
            id: "fourth",
            question: "كيف يمكنني ضمان أمان بياناتي عند استخدام خدمات التحليلات؟",
            answer:
                "نحن نعطي الأولوية لأمان البيانات من خلال استخدام التشفير، وبروتوكولات الوصول الآمنة، والامتثال للوائح حماية البيانات. تضمن خدماتنا حماية معلوماتك الحساسة جيدًا أثناء التحليل.",
        },
        {
            id: "fifth",
            question: "هل تقدمون تحليلات في الوقت الفعلي؟",
            answer:
                "نعم، نحن نقدم تحليلات بيانات في الوقت الفعلي تساعدك على مراقبة مقاييس الأعمال الرئيسية على الفور. وهذا يسمح باتخاذ قرارات أسرع واستجابة أفضل لظروف السوق المتغيرة.",
        },
        {
            id: "sixth",
            question: "ما هي الصناعات التي يمكن أن تستفيد من خدمات تحليلات البيانات لديكم؟",
            answer:
                "تلبي خدماتنا مجموعة واسعة من الصناعات، بما في ذلك الرعاية الصحية، والتمويل، وتجارة التجزئة، والتصنيع، والمزيد. نحن نصمم حلولًا لتلبية الاحتياجات الفريدة لكل قطاع، مما يساعد الشركات على تحسين العمليات والبقاء قادرة على المنافسة.",
        },
        {
            id: "seventh",
            question: "هل أحتاج إلى برنامج متخصص لاستخدام خدمات تحليلات البيانات؟",
            answer:
                "لا، نحن نقدم حلولًا مخصصة يمكن أن تتكامل بسلاسة مع أنظمة البرامج الموجودة لديك. يضمن فريقنا تنفيذًا سلسًا، حتى تتمكن من تحقيق أقصى استفادة من بياناتك دون الحاجة إلى أدوات متخصصة.",
        },
    ]
}